
var industry = [
    {
        "name": "学校",
        "level11s": [
            {
                "name": "高等教育",
				"level111s": []
            },
			{
			    "name": "基础教育",
				"level111s": []
			},
			{
			    "name": "职业教育",
				"level111s": []
			},
			{
			    "name": "幼儿教育",
				"level111s": []
			}
        ]
    },
    {
        "name": "企业",
        "level11s": [
            {
                "name": "经销商/代理商",
				"level111s": [
				 //    {
				 //        "name": "经销商"
				 //    },
					// {
					//     "name": "代理商"
					// }
				]
            },
			{
				"name":"投资公司/招投标代理公司",
				"level111s": []
			},
			{
				"name":"集成商",
				"level111s": []
			},
			{
				"name":"制造商",
				"level111s": []
			},
			{
				"name":"教育培训及咨询机构",
				"level111s": []
			},
			{
				"name":"教育出版社/教育出版集团",
				"level111s": [
				 //    {
				 //        "name": "教育出版社"
				 //    },
					// {
					//     "name": "教育出版集团"
					// }
				]
			},
			{
				"name":"其他",
				"level111s": []
			}
        ]
    },
    {
        "name": "媒体",
        "level11s": [
            {
                "name": "媒体",
				"level111s": []
            }
        ]
    },
    {
      "name": "教育行政管理部门、协会、学会",
      "level11s": [
          {
              "name": "教育行政管理部门",
			  "level111s": []
          },
		  {
		      "name": "协会",
			  "level111s": []
		  },
		  {
		      "name": "学会",
			  "level111s": []
		  }
      ]
    }
]
export default industry;